import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TabsState {
  text: string;
}

const initialState: TabsState = {
  text: '',
};

const helpersSlice = createSlice({
  name: 'helpers',
  initialState,
  reducers: {
    setStoredText(state, action: PayloadAction<string>) {
      state.text = action.payload;
    },
  },
});

export const { setStoredText } = helpersSlice.actions;

export const selectText = (state: any) => state.helpers.text;

export default helpersSlice.reducer;
